import React from 'react';
import {i18n} from 'react-i18n';
import AppStore from '../stores/AppStore';
import TemplateData from '../utility/getTemplateData';
import GlobalBanner from '../common/globalBanner';
import SubHeader from '../common/subHeader';
import Amount from '../common/amount';
import CancelAndReturn from '../common/cancelAndReturn';

const STYLES = {
	donateBtn: {
		maxWidth: '360px',
		margin: '20px auto'
	},
	centralFormWrapper: {
		width: '400px',
		margin: '0 auto'
	},
	donationSeparator: {
		marginBottom: '25px'
	},
	formLabelBold: {
		fontWeight: 'bold'
	},
	formLabelLeft: {
		width: '50%',
		textAlign: 'left'
	},
	formLabelRight: {
		width: '50%',
		textAlign: 'right'
	},
	formLabelCenter: {
		width: '100%',
		marginTop: '10px',
		textAlign: 'center'
	},
	conversionBlock: {
		margin: '20px 15px 30px 15px',
		padding: '15px 0 10px 0',
		backgroundColor: '#F1F8FC',
		borderRadius: '5px'
	},
	policyMsg: {
		fontSize: '0.85em',
		textAlign: 'center',
		color: '#848B8E'
	}
};

const CrossBorder = React.createClass({
	mixins: [i18n('guest/crossBorder')],

	getInitialState() {
		let fundingOptions = AppStore.getFundingOptions();
		let fundingSources = fundingOptions.sources[0];
		let paymentNetwork = fundingSources.payment_card.network.toLowerCase();
		paymentNetwork = paymentNetwork.charAt(0).toUpperCase() + paymentNetwork.slice(1);
		let paymentDigits = fundingSources.payment_card.last_4;
		let fundsIn = fundingOptions.currency_conversion.funds_in;
		let fundsOut = fundingOptions.currency_conversion.funds_out;
		let exchangeRate = fundingOptions.currency_conversion.exchange_rate;
		exchangeRate = parseFloat(exchangeRate).toFixed(2);

		return {
			subHeaderLabel: TemplateData.donationName,
			amountAmount: AppStore.getDonationAmount(),
			amountSymbol: AppStore.getDonationSymbol(),
			amountCode: AppStore.getDonationCode(),
			paymentCard: `${paymentNetwork} x-${paymentDigits}`,
			fundsIn: `$${fundsIn.value} ${fundsIn.currency}`,
			fundsOut: `$${fundsOut.value} ${fundsOut.currency}`,
			exchangeRate: `1 ${fundsIn.currency} = ${exchangeRate} ${fundsOut.currency}`
		};
	},

	handleDonateClick() {
		// TODO: finish.
		alert('[Submit form]');
	},

	render() {
		return (<div className="donate_wrapper">
			<div className="container">
				<GlobalBanner logourl={this.state.logourl}/>
				<SubHeader label={this.state.subHeaderLabel}/>
				<Amount
					amount={this.state.amountAmount}
					symbol={this.state.amountSymbol}
					code={this.state.amountCode}/>

				<div style={STYLES.centralFormWrapper}>
					<label style={STYLES.formLabelBold}>
						{this.i18n('label.donatingFrom')}
					</label>
					<div
						className="donate_linner_div center-block"
						style={STYLES.donationSeparator}/>

					<label style={STYLES.formLabelLeft}>
						{this.state.paymentCard}
					</label>
					<label style={STYLES.formLabelRight}>
						{this.state.fundsIn}
					</label>
				</div>

				<div style={STYLES.conversionBlock}>
					<div style={STYLES.centralFormWrapper}>
						<label style={{
							...STYLES.formLabelLeft,
							...STYLES.formLabelBold}}>
							{this.i18n('label.youDonate')}
						</label>
						<label style={{
							...STYLES.formLabelRight,
							...STYLES.formLabelBold}}>
							{this.state.fundsIn}
						</label>

						<label style={STYLES.formLabelLeft}>
							{this.i18n('label.charityGet')}
						</label>
						<label style={STYLES.formLabelRight}>
							{this.state.fundsOut}
						</label>

						<label style={STYLES.formLabelCenter}>
							{this.i18n('label.conversion')} {this.state.exchangeRate}
						</label>
					</div>
				</div>

				<div
					style={STYLES.policyMsg}
					dangerouslySetInnerHTML={{__html: this.i18n('label.policies')}}/>

				<div style={STYLES.donateBtn}>
					<button
						type="button"
						className="vx_btn vx_btn-block"
						onClick={this.handleDonateClick}>
						{this.i18n('label.donatenow')}
					</button>
				</div>
				<CancelAndReturn />
			</div>
		</div>);
	}
});

export default CrossBorder;



/** WEBPACK FOOTER **
 ** ./guest/crossBorder.js
 **/